import React from 'react'
import { ILoginUserInput } from 'app/shared/data-access/users/login-user/login-user-input'
import { UserRepository } from 'app/shared/data-access/users'
import UserLoginView from './user-login-view'
import { useUserContext } from 'app/shared/state/user-context'
import { useToastContext } from 'app/shared/state/toast-context'
import { useHistory } from 'react-router-dom'
import { useIsBusyContext } from 'app/shared/state/is-busy-context'

const UserLogin = () => {
  const { addToast } = useToastContext()
  const { isBusy, setIsBusy } = useIsBusyContext()

  const { reloadCurrentUser } = useUserContext()

  const history = useHistory()

  /**
   * @param {ILoginUserInput} input
   */
  const login = async (input: ILoginUserInput) => {
    setIsBusy(true)
    const loginResult = await UserRepository.loginUser(input)
    setIsBusy(false)

    if (!loginResult) {
      addToast({
        variant: 'error',
        message: 'Er is iets misgegaan tijdens het inloggen',
      })
      return
    }

    if (loginResult.error && loginResult.statusCode === 403) {
      addToast({
        variant: 'error',
        message: `Inloggen mislukt. ${loginResult.error}`,
      })
      return
    }

    if (loginResult.error) {
      addToast({
        variant: 'error',
        message: loginResult.error,
      })
      return
    }

    if (!loginResult.credentialsAreValid) {
      addToast({
        variant: 'error',
        message: 'Uw inloggegevens zijn onjuist',
      })
      return
    }

    let redirectUrl = loginResult.needsTwoFa ? `/two-fa-login/?email=${input.email}` : '/'
    if (loginResult.needsTwoFa && !loginResult.isEmailTwoFa) {
      redirectUrl += '&totp'
    }

    await reloadCurrentUser()

    history.push(redirectUrl)
  }

  return <UserLoginView onLogin={login} isBusy={isBusy} />
}

export default UserLogin
